var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "#30475F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70801 6.33334C7.83356 6.33334 7.12467 7.04223 7.12467 7.91668V14.25C7.12467 15.1245 7.83356 15.8333 8.70801 15.8333H10.2913C11.1658 15.8333 11.8747 15.1245 11.8747 14.25V7.91668C11.8747 7.04223 11.1658 6.33334 10.2913 6.33334H8.70801ZM3.16634 9.50001C2.29189 9.50001 1.58301 10.2089 1.58301 11.0833V14.25C1.58301 15.1245 2.29189 15.8333 3.16634 15.8333H4.74967C5.62413 15.8333 6.33301 15.1245 6.33301 14.25V11.0833C6.33301 10.2089 5.62413 9.50001 4.74967 9.50001H3.16634Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 4.74999C12.667 3.87554 13.3759 3.16666 14.2503 3.16666H15.8337C16.7081 3.16666 17.417 3.87554 17.417 4.74999V14.25C17.417 15.1244 16.7081 15.8333 15.8337 15.8333H14.2503C13.3759 15.8333 12.667 15.1244 12.667 14.25V4.74999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartFill);
export default __webpack_public_path__ + "static/media/bar-chart-fill.769968446e0b5aee61f398f8ef0b95b4.svg";
export { ForwardRef as ReactComponent };